import { render, staticRenderFns } from "./chart-vertical-new-ux.vue?vue&type=template&id=582ce638&"
import script from "./chart-vertical-new-ux.vue?vue&type=script&lang=js&"
export * from "./chart-vertical-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582ce638')) {
      api.createRecord('582ce638', component.options)
    } else {
      api.reload('582ce638', component.options)
    }
    module.hot.accept("./chart-vertical-new-ux.vue?vue&type=template&id=582ce638&", function () {
      api.rerender('582ce638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/chart-vertical-new-ux.vue"
export default component.exports